module.exports = "<div class=\"alert alert-danger alert-dismissible fade show\" role=\"alert\">\n  {{errorMessage}}\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/payment-error/payment-error.component.html
// module id = ../../../../../src/app/components/payment/payment-error/payment-error.component.html
// module chunks = main